package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class DashboardStatsDto(
    val podcasts: CountStat,
    val audiobooks: CountStat,
    val episodes: EpisodeStats,
    val contentTypes: Map<String, Int>,
    val podcasters: CountStat,
    val authors: CountStat,
    val readers: CountStat,
    val tags: CountStat,
    val homeSections: HomeSectionStats
)

@Serializable
data class EpisodeStats(
    val total: Int,
    val podcastEpisodes: Int,
    val audiobookEpisodes: Int
)

@Serializable
data class CountStat(
    val total: Int
)

@Serializable
data class HomeSectionStats(
    val active: Int
)
